'use client';

import { OBRAS_GENEROS } from '@/constants/obras-generos';
import { FORMATO_TODOS_SENTINEL } from '@/components/FormatoPicker';
import { formatoPillClassName } from '@/components/obra/formatoPillStyles';

const TODOS_ITEM = { id: 'todos' as const, label: 'Todos', formato: FORMATO_TODOS_SENTINEL, color: '#f97316' };

type GeneroItem = (typeof OBRAS_GENEROS)[number] | typeof TODOS_ITEM;

export function FormatoHomeStrip({
    selectedFormato,
    onSelect,
    showTodos = false,
}: {
    selectedFormato: number;
    onSelect: (formato: number) => void;
    showTodos?: boolean;
}) {
    const items: GeneroItem[] = showTodos ? [TODOS_ITEM, ...OBRAS_GENEROS] : [...OBRAS_GENEROS];

    const pill = (genero: GeneroItem) => {
        const ativo = genero.formato === selectedFormato;
        return (
            <button
                key={genero.id}
                type="button"
                onClick={() => onSelect(genero.formato)}
                className={formatoPillClassName(ativo)}
                style={
                    ativo
                        ? {
                              backgroundColor: `${genero.color}20`,
                              color: genero.color,
                              borderColor: genero.color,
                          }
                        : {}
                }
            >
                {genero.label}
            </button>
        );
    };

    return (
        <>
            <div className="md:hidden">
                <div className="rounded-2xl border border-white/10 bg-black/35 px-4 py-3 backdrop-blur-[1px]">
                    <div className="flex flex-col items-center gap-2.5">
                        <div className="flex flex-wrap justify-center gap-2">{items.slice(0, 4).map(pill)}</div>
                        <div className="flex flex-wrap justify-center gap-2">{items.slice(4).map(pill)}</div>
                    </div>
                </div>
            </div>

            <div className="hidden md:block">
                <div className="rounded-2xl border border-white/10 bg-black/35 px-4 py-3 backdrop-blur-[1px]">
                    <div className="flex flex-nowrap items-center justify-center gap-2.5 overflow-x-auto pb-0.5 [-ms-overflow-style:none] [scrollbar-width:none] md:gap-3 [&::-webkit-scrollbar]:hidden">
                        {items.map(pill)}
                    </div>
                </div>
            </div>
        </>
    );
}
